import React, { useCallback } from 'react';

import { Box, Button } from '@mui/material';

import useStyles from './styles';

const ALL = 'All';
const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const OPTIONS = [
    { label: ALL, value: null },
    ...MONTHS.map((month, index) => ({ label: month, value: index + 1 })).reverse()
];

interface Props {
    selected?: number;
    onSelect: (month: number | null) => void;
    getOptionHref: (month: number | null) => string;
    className?: string;
}

const MonthFilter: React.FC<Props> = ({ selected, onSelect, getOptionHref, className }) => {
    const { classes, cx } = useStyles();

    const handleSelect = useCallback(
        (event) => {
            event.preventDefault();
            const { option } = event.currentTarget.dataset;
            onSelect && onSelect(option || null);
        },
        [onSelect]
    );

    return (
        <Box className={cx(classes.container, className)}>
            {OPTIONS.map((option) => {
                const additional = getOptionHref
                    ? {
                          component: 'a',
                          href: getOptionHref(option.value)
                      }
                    : {};
                return (
                    <Button
                        key={option.label}
                        className={cx(classes.button, { [classes._selected]: option.value === (selected || null) })}
                        variant="outlined"
                        data-option={option.value}
                        onClick={handleSelect}
                        {...additional}
                    >
                        {option.label}
                    </Button>
                );
            })}
        </Box>
    );
};

export default MonthFilter;
